(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["cart"]) return;
  try {
    
$('.cartView').click(function(){
  	$('#cartBox').fadeIn(0);
	$(this).addClass('active')
  return false;
})
  $('body').on('click','#cartBox .continueBtn,#cartBox .exit',function(){
    $('#cartBox').fadeOut(0);
	$(this).removeClass('active')
    return false;
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["country-information"] && !window.DesignMode) return;
  try {
    
  $(function() {
    if($('#countryInformation').size()){
      $('#footer .country>div').each(function(){
        var info = $(this).html();
        $('#countryInformation .rows').append('<div><div class="box">'+info+'</div></div>');
      })
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !window.DesignMode) return;
  try {
    
$('#faqAccordion li').click(function(){
  $('#faqAccordion li').removeClass('active')
  $('#faqAccordion li p').slideUp();
  $(this).addClass('active')
  $('#faqAccordion li.active p').slideDown();
})
function faqAccordionSelect(active){
  $('#faqAccordion .filterList li').hide();
  //$(this).addClass('active')
  $('#faqAccordion .filterList').find('.'+active).show();

  var total = $('#faqAccordion .filterList').find('.'+active).length;
  if(total == 0){
    $('#faqAccordion .filterList .empty').show();
  }else{
    $('#faqAccordion .filterList .empty').hide();
  }
}
$('#faqAccordion .filterMenu li').click(function(){
  $('#faqAccordion .filterMenu li').removeClass('active');
  var active = $(this).data('class');
  faqAccordionSelect(active);
})
$('#faqAccordion .filterMenuOption').on('change', function() {
    var select = $(this).find(":selected").val();
    faqAccordionSelect(select);
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !window.DesignMode) return;
  try {
    
  $('footer .country>div').click(function(){
    var t = $(this),
        c = t.html();
    $('#countryInfo .body').html(c)
    $('#countryInfo').fadeIn();
  });
  $('#countryInfo .close').click(function(){
    $('#countryInfo').fadeOut();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift"]) return;
  try {
    

var lastScrollTop = 0;
$(window).scroll(function(event){
   var st = $(this).scrollTop();
   if (st > lastScrollTop){
      $('body').addClass('gift-active');
   } else {
      $('body').removeClass('gift-active');
   }
   lastScrollTop = st;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hair-loss-factors"]) return;
  try {
    
 var swiper = new Swiper("#hairLossFactors .swiper", {
   spaceBetween: 30,
   centeredSlides: true,
   loop: false,
   pagination: {
     el: "#hairLossFactors .swiper-pagination",
     clickable: true,
   },
   breakpoints: {
     0: {
       slidesPerView: 2,
       autoHeight: true,
     },
     1024: {
       slidesPerView: 3,
     },
   }
 });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["help"] && !window.DesignMode) return;
  try {
    
  $('body').on('click','#helpBox .messenger',function(){
    var t = $('#whatsapp')
    t.toggleClass('active');;
    t.find('.more').slideToggle();
    return false;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["links-card"]) return;
  try {
     
$('#linkCard main ul li').each(function(){
	var t = $(this),
		a = t.find('.link').attr('href')
		wpText = t.parents('ul').attr('data-wptext'),
		liText = t.find('.text')
		content = null; 
	
	if(a.search("wsend") > 0){ 
		var tel = a.replace('https://wsend.co/','');	
		var wpLink = 'https://wa.me/'+tel+'?text='+wpText;
		t.find('.link').attr('href',wpLink);
		 content = '<a href="tel:'+tel+'"><i class="icon icon-phone"></i> Call</a>';
		 content  += '<a href="'+wpLink+'"><i class="icon icon-bubble"></i> Send Message</a>';
		liText.append('<div class="options">'+content+'</div>');
	}

	if(a.search("wa.me") > 0){ 
		var tel = a.replace('https://wa.me/','');
		var wpLink = 'https://wa.me/'+tel+'?text='+wpText;
		t.find('.link').attr('href',wpLink);
		 content = '<a href="tel:'+tel+'"><i class="icon icon-phone"></i> Call</a>';
		 content  += '<a href="'+wpLink+'"><i class="icon icon-bubble"></i> Send Message</a>';
		liText.append('<div class="options">'+content+'</div>');
	}


});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navigation-top-menu"]) return;
  try {
    
$('#burgerMenu .close').click(function(){
  $('#burgerMenu .box').show()
  $('#burgerMenu').removeClass('active');
  $('#burgerMenu').hide()
});
$('body').on('click','#burgerMenu .menuLinks a',function(){
  var t = $(this),
      li = t.parent(),
      h = t.attr('href');
 if(h == '#' || h == '/ar#'){ 
   li.toggleClass('active');
   li.find('ul').slideToggle(0);
   return false;
 }
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navigation-top"]) return;
  try {
    
$('#fixedTop .hamburgerMenu').click(function(){
  $('#burgerMenu').show().addClass('active');
  $('#burgerMenu .box').show();
  return false;
});
if($('#notification').length){
 $('#fixedTop').addClass('notification');
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-content"] && !window.DesignMode) return;
  try {
    
var productContent = new Swiper("#productContent .mySwiper", {
  loop: false,
  centeredSlides: false,
  spaceBetween: 30,
  touchStartPreventDefault: false,
  pagination: {
    el: "#productContent .swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: "#productContent .swiper-button-next",
    prevEl: "#productContent .swiper-button-prev",
  },
  breakpoints: {
    0: {
      slidesPerView: 1,
      autoHeight: true,
    },
    1024: {
      slidesPerView: 3,
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-detail"]) return;
  try {
    
$('.productDetail .option').click(function(){
  var t = $(this),
      g = t.parent();
  g.find('.option').removeClass('active');
  g.find('input').removeAttr('checked');
  t.addClass('active');
  t.find('input').attr('checked',"true");


})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-before-after"]) return;
  try {
    
$("#slider").on("input change", (e)=>{
  const sliderPos = e.target.value;
  // Update the width of the foreground image
  $('.foreground-img').css('width', `${sliderPos}%`)
  // Update the position of the slider button
  $('.slider-button').css('left', `calc(${sliderPos}% - 18px)`)
});
$('#beforeAfterSlider li:first-child').addClass('active');
$('.beforeAfterBox .img').css('background-size',$('.img.background-img.before').width());
$('#beforeAfterSlider li').click(function(){
  var t = $(this),
      b = t.attr('data-before'),
      a = t.attr('data-after'),
      f = $('#beforeAfterSlider');
  f.find('.before').css('background-image','url('+b+')');
  f.find('.after').css('background-image','url('+a+')');
  f.find('li').removeClass('active');
  t.addClass('active');
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-home"] && !window.DesignMode) return;
  try {
    
var sliderHome = new Swiper("#sliderHome .mySwiper", {
  effect: "fade",
  navigation: {
    nextEl: "#sliderHome .swiper-button-next",
    prevEl: "#sliderHome .swiper-button-prev",
  },
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-how-to-user"] && !window.DesignMode) return;
  try {
    
if($(window).width() > 960 ){
 var swiper = new Swiper("#slideHowToUser .swiper", {
   spaceBetween: 30,
   freeMode: false,
   autoplay: {
     delay: 3000,
   },
   pagination: {
     el: "#slideHowToUser .swiper-pagination",
     clickable: true,
   },
   breakpoints: {
     0: {
       slidesPerView: 2,
       centeredSlides: true,
       autoHeight: true,
     },
     1024: {
       slidesPerView: 3
     }
   }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-product-new"] && !window.DesignMode) return;
  try {
    
var sliderProducts = new Swiper("#sliderProducts .mySwiper", {
  slidesPerView: 3,
  loop: false,
  spaceBetween: 30,
  autoplay: {
     delay: 3000,
  },
  pagination: {
    el: "#sliderProducts .swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: "#sliderProducts .next",
    prevEl: "#sliderProducts .prev",
  },
  breakpoints: {
    0: {
      slidesPerView: 2,
      centeredSlides: true,
      loop: true,
    },
    1024: {
      slidesPerView: 3
    },
  }
});
//var sliderHeight = $('#sliderProducts .slider').height();
//$('#sliderProducts').height(sliderHeight);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-products"] && !window.DesignMode) return;
  try {
    
var sliderProducts = new Swiper("#sliderProducts .mySwiper", {
  slidesPerView: 3,
  loop: false,
  spaceBetween: 30,
  autoplay: {
     delay: 3000,
  },
  pagination: {
    el: "#sliderProducts .swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: "#sliderProducts .next",
    prevEl: "#sliderProducts .prev",
  },
  breakpoints: {
    0: {
      slidesPerView: 2,
      centeredSlides: true,
      loop: true,
    },
    1024: {
      slidesPerView: 3
    },
  }
});
//var sliderHeight = $('#sliderProducts .slider').height();
//$('#sliderProducts').height(sliderHeight);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-reviews"] && !window.DesignMode) return;
  try {
    
var sliderReviews = new Swiper("#sliderReviews .mySwiper", {
  loop: true,
  centeredSlides: true,
  spaceBetween: 0,
  autoplay: {
   delay: 3000,
  },
  touchStartPreventDefault: false,
  pagination: {
    el: "#sliderReviews .swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: "#sliderReviews .swiper-button-next",
    prevEl: "#sliderReviews .swiper-button-prev",
  },
  breakpoints: {
    0: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 3,
    },
  }
});
$(function(){
   var curHeight = $('.text p').height();
   if(curHeight <= 93)
       $('.textReadMore').show();
   else
       $('.textReadMore').hide();
});
$('.textReadMore').click(function(){
  var readmore = $('.textReadMore');
  if (readmore.data('status') == false ) {
      readmore.text("{{ section.settings.readLess }}");
  } else {
      readmore.text("{{ section.settings.remoMore }}");
  }
  $(this).parent().toggleClass("textHeightAuto");
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-social-story"] && !window.DesignMode) return;
  try {
    
 var sliderSocialStory = new Swiper("#sliderSocialStory .swiper", {
   spaceBetween: 30,
   centeredSlides: false,
   loop: false,
   noSwipingClass: 'swiper-no-swiping',
   pagination: {
     el: "#sliderSocialStory .swiper-pagination",
     clickable: true,
   },
   autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
   allowTouchMove: false,
   breakpoints: {
     0: {
       slidesPerView: 4,
       centeredSlides: true,
       loop: true,
     },
     1024: {
       slidesPerView: 4,
     },
   }
 });
 $('#sliderSocialStory .story').height($('#sliderSocialStory .story').width());
 $('#sliderSocialStory .swiper .swiper-slide').click(function(){

 });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-video-card"] && !window.DesignMode) return;
  try {
    
 var sliderVideo = new Swiper("#sliderVideo .swiper", {
   slidesPerView: 4,
   spaceBetween: 30,
   centeredSlides: false,
   loop: false,
   autoplay: {
      delay: 3000,
   },
   noSwipingClass: 'swiper-no-swiping',
   pagination: {
     el: "#sliderVideo .swiper-pagination",
     clickable: true,
   },
   navigation: {
     nextEl: "#sliderVideo .next",
     prevEl: "#sliderVideo .prev",
   },
   allowTouchMove: false,
 });
 var sliderVideoView = $('#sliderVideo .view');
 sliderVideoView.find('span').click(function(){
   sliderVideoView.fadeOut(function(){
     sliderVideoView.find('div').html(" ");
   });
 });
 $('#sliderVideo .swiper .swiper-slide').click(function(){
   var t = $(this),
       title = t.data('title'),
       type = t.data('type'),
       id = t.data('id');
   sliderVideoView.find('div').html('<h1>'+title+'</h1><iframe width="100%" height="100%" src="https://www.youtube.com/embed/'+id+'" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');
   sliderVideoView.fadeIn();
 });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-video"] && !window.DesignMode) return;
  try {
    
 var sliderVideo = new Swiper("#sliderVideo .swiper", {
   spaceBetween: 30,
   centeredSlides: false,
   loop: false,
   noSwipingClass: 'swiper-no-swiping',
   pagination: {
     el: "#sliderVideo .swiper-pagination",
     clickable: true,
   },
   navigation: {
     nextEl: "#sliderVideo .next",
     prevEl: "#sliderVideo .prev",
   },
   allowTouchMove: false,
   breakpoints: {
     0: {
       slidesPerView: 3,
       centeredSlides: true,
       loop: true,
     },
     1024: {
       slidesPerView: 4,
     },
   }
 });
 var sliderVideoView = $('#sliderVideo .view');
 sliderVideoView.find('span').click(function(){
   sliderVideoView.fadeOut(function(){
     sliderVideoView.find('div').html(" ");
   });
 });
 $('#sliderVideo .swiper .swiper-slide').click(function(){
   var t = $(this),
       title = t.data('title'),
       type = t.data('type'),
       id = t.data('id');
   sliderVideoView.find('div').html('<h1>'+title+'</h1><iframe width="100%" height="100%" src="https://www.youtube.com/embed/'+id+'" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');
   sliderVideoView.fadeIn();
 });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whatsapp-box"] && !window.DesignMode) return;
  try {
    
  $('body').on('click','#whatsapp .btnBox',function(){
    var t = $(this).parent();
    t.toggleClass('active');
    t.find('.more').slideToggle();
    return false;
  });

  } catch(e) { console.error(e); }
})();

})();
